import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  required,
  email,
  TopToolbar,
  ShowButton,
  ListButton,
} from 'react-admin';
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Box,
  Avatar,
  Divider,
} from '@mui/material';
import {
  Person as PersonIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
} from '@mui/icons-material';
import RolePermissionManager from '../../components/RolePermissionManager';
import { useRolePermissionEditTransform } from '../../hooks/useRolePermissionTransform';

const EditTopToolbar = () => (
  <TopToolbar>
    <ShowButton />
    <ListButton />
  </TopToolbar>
);

const ClientsEdit = () => {
  const { transformForEdit, transformForSave } = useRolePermissionEditTransform();

  return (
    <Edit
      title='Editar Cliente'
      actions={<EditTopToolbar />}
      mutationMode='pessimistic'
      transform={transformForSave}
    >
      <Box sx={{ margin: '0 auto', padding: 2 }}>
        <SimpleForm>
          {/* Información Básica */}
          <Card sx={{ mb: 3, boxShadow: 3 }}>
            <CardHeader
              avatar={
                <Avatar sx={{ bgcolor: 'primary.main' }}>
                  <PersonIcon />
                </Avatar>
              }
              title={
                <Typography variant='h6' component='div'>
                  Información Básica
                </Typography>
              }
              subheader='Datos principales del cliente'
            />
            <Divider />
            <CardContent>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextInput
                  source='clientName'
                  label='Nombre del Cliente'
                  validate={[required()]}
                  fullWidth
                  variant='outlined'
                  helperText='Nombre completo o razón social del cliente'
                />
              </Box>
            </CardContent>
          </Card>

          {/* Información de Contacto */}
          <Card sx={{ mb: 3, boxShadow: 3 }}>
            <CardHeader
              avatar={
                <Avatar sx={{ bgcolor: 'secondary.main' }}>
                  <EmailIcon />
                </Avatar>
              }
              title={
                <Typography variant='h6' component='div'>
                  Información de Contacto
                </Typography>
              }
              subheader='Datos de contacto del cliente'
            />
            <Divider />
            <CardContent>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextInput
                  source='clientEmail'
                  label='Correo Electrónico'
                  validate={[required(), email()]}
                  fullWidth
                  variant='outlined'
                  InputProps={{
                    startAdornment: (
                      <EmailIcon sx={{ mr: 1, color: 'action.active' }} />
                    ),
                  }}
                  helperText='Dirección de correo electrónico principal'
                />
                <TextInput
                  source='clientPhoneContact'
                  label='Teléfono de Contacto'
                  validate={[required()]}
                  fullWidth
                  variant='outlined'
                  InputProps={{
                    startAdornment: (
                      <PhoneIcon sx={{ mr: 1, color: 'action.active' }} />
                    ),
                  }}
                  helperText='Número de teléfono principal'
                />
              </Box>
            </CardContent>
          </Card>

          {/* Componente Universal de Roles y Permisos */}
          <RolePermissionManager
            title="Roles y Permisos del Cliente"
            subtitle="Modificar roles y niveles de permisos para el cliente"
            helperText="Los roles determinan qué usuarios pueden acceder a este cliente y qué acciones pueden realizar."
          />
        </SimpleForm>
      </Box>
    </Edit>
  );
};

export default ClientsEdit;
